import { gql } from '@apollo/client';

export const REGISTER_USER = gql`
  mutation RegisterUser($newUser: UserRegisterInput!) {
    registerUser(newUser: $newUser) {
      user {
        id
        fullName
        userName
        email
        avatar
      }
      token
    }
  }
`;

export const CHANGE_PASSWORD = gql`
  mutation ChangePassword($password: String!, $newPassword: String!) {
    changePassword(password: $password, newPassword: $newPassword)
  }
`;

export const EDIT_USER = gql`
  mutation EditUser($newUser: UserInput!) {
    editUser(newUser: $newUser) {
      id
      fullName
      userName
      email
      avatar
    }
  }
`;

export const UPDATE_GEO_LOCATION = gql`
  mutation UpdateGeoLocation($geoLocation: String!) {
    updateGeoLocation(geoLocation: $geoLocation)
  }
`;

export const CONFIRM_EMAIL = gql`
  mutation ConfirmEmail($token: String!) {
    confirmEmail(token: $token)
  }
`;

export const VERIFY_EMAIL_OTP = gql`
  mutation VerifyEmailOtp($identifier: String!, $otp: String!) {
    verifyEmailOtp(identifier: $identifier, otp: $otp)
  }
`;

export const RESEND_EMAIL_OTP = gql`
  mutation ResendEmailOtp($identifier: String!) {
    resendEmailOtp(identifier: $identifier)
  }
`;

// The server spells it `forgetPassword`, not `forgotPassword`. Returns true
// unconditionally, including for an address that has no account — the neutral
// response is the anti-enumeration behaviour, not a bug to work around.
export const FORGET_PASSWORD = gql`
  mutation ForgetPassword($email: String!) {
    forgetPassword(email: $email)
  }
`;

export const RESET_PASSWORD = gql`
  mutation ResetPassword($token: String!, $password: String!) {
    resetPassword(token: $token, password: $password)
  }
`;

export const TOGGLE_FAVORITE_BRAND = gql`
  mutation ToggleFavoriteBrand($id: ID!) {
    toggleFavoriteBrand(id: $id)
  }
`;

export const TOGGLE_FAVORITE_STORE = gql`
  mutation ToggleFavoriteStore($id: ID!) {
    toggleFavoriteStore(id: $id)
  }
`;

export const TOGGLE_FAVORITE_SHOP = gql`
  mutation ToggleFavoriteShop($id: ID!) {
    toggleFavoriteShop(id: $id)
  }
`;

export const TOGGLE_SUBSCRIBE_SHOP = gql`
  mutation ToggleSubscribeShop($id: ID!) {
    toggleSubscribeShop(id: $id)
  }
`;

export const TOGGLE_SUBSCRIBE_BRAND = gql`
  mutation ToggleSubscribeBrand($id: ID!) {
    toggleSubscribeBrand(id: $id)
  }
`;

export const TOGGLE_SUBSCRIBE_STORE = gql`
  mutation ToggleSubscribeStore($id: ID!) {
    toggleSubscribeStore(id: $id)
  }
`;

export const SUBMIT_FEEDBACK = gql`
  mutation SubmitFeedback($input: FeedbackInput!) {
    submitFeedback(input: $input) {
      id
      createdAt
    }
  }
`;

/**
 * Exchange a Google ID token for a PromoStork session.
 *
 * Selection set is deliberately identical to LOGIN_USER's: both produce an
 * AuthUser and both feed the same `signIn(user, token)` call, so any drift
 * between them would surface as a half-populated user on one path only.
 *
 * `nonce` is optional — GIS sets one, the mobile client cannot.
 */
export const SIGN_IN_WITH_GOOGLE = gql`
  mutation SignInWithGoogle($idToken: String!, $nonce: String) {
    signInWithGoogle(idToken: $idToken, nonce: $nonce) {
      user {
        id
        email
        avatar
        userName
        twoFactorEnabled
        fullName
      }
      token
    }
  }
`;
